import React from 'react'
import { createRoot } from 'react-dom/client'
import CommunityPostPage from '../components/CommunityPostPage'
import { initSocialProofFromDOM } from 'utils/socialProofToast'
import { mountWelcomeCoupon } from './mountWelcomeCoupon'

document.addEventListener('DOMContentLoaded', () => {
  initSocialProofFromDOM()
  mountWelcomeCoupon()
  const container = document.getElementById('community-post-page')
  if (!container) return

  const post = JSON.parse(container.dataset.post)
  const teamId = parseInt(container.dataset.teamId, 10)
  const teamSlug = container.dataset.teamSlug
  const canInteract = container.dataset.canInteract === 'true'
  const isOwnerOrAdmin = container.dataset.isOwnerOrAdmin === 'true'
  const categories = container.dataset.categories ? JSON.parse(container.dataset.categories) : []
  const currentUser = container.dataset.currentUser ? JSON.parse(container.dataset.currentUser) : null
  const translations = container.dataset.translations ? JSON.parse(container.dataset.translations) : {}

  const root = createRoot(container)
  root.render(
    <CommunityPostPage
      post={post}
      teamId={teamId}
      teamSlug={teamSlug}
      canInteract={canInteract}
      isOwnerOrAdmin={isOwnerOrAdmin}
      categories={categories}
      currentUser={currentUser}
      translations={translations}
    />
  )
})
